import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../app/store/AuthStore';

const mapStateToProps = state => ({
    schools: state.auth.organizations,
});

const mapDispatchToProps = dispatch => ({
    getSchools: bindActionCreators(actionCreators, dispatch).getAllPublicOrganizations,
});

export const withSchools = (Component) => {
    class WithSchools extends React.Component {
        componentDidMount() {
            if (!this.props.schools) {
                this.props.getSchools();
            }
        }

        render() {
            return <Component {...this.props} schools={this.props.schools || []} />;
        }
    }

    WithSchools.propTypes = {
        schools: PropTypes.arrayOf(PropTypes.object),
        getSchools: PropTypes.func.isRequired,
    };

    WithSchools.defaultProps = {
        schools: null,
    };

    return connect(
        mapStateToProps,
        mapDispatchToProps,
    )(WithSchools);
};

export default withSchools;
